import { ApolloError } from "@apollo/client";

export function getErrorCode(error: ApolloError): number | null {
  const code = error?.graphQLErrors?.[0]?.extensions?.code;
  return code != null ? Number(code) : null;
}

/**
 * Проверяет успешность выполнения Apollo запроса
 * @param loading - флаг загрузки
 * @param error - ошибка запроса
 * @returns true если запрос завершен без ошибок
 */
export const isQuerySuccess = (loading: boolean, error: any): boolean =>
  !loading && !error;
